import { ApiResponse, axiosInstance, AxiosErrorCustom } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const AssignCasesInputSchema = z.object({
  caseIds: z
    .array(z.string({ required_error: 'Conversation ID is required!' }).min(1))
    .min(1, { message: 'At least one conversation ID is required!' }),
  userId: z.string({ required_error: 'User ID is required!' }).min(1),
  teamId: z.string({ required_error: 'Team ID is required!' }).min(1).nullable(),
});
export type TAssignCasesInput = z.infer<typeof AssignCasesInputSchema>;
export type TAssignCasesResponse = ApiResponse<{ message: string }>;

export const assignCases = async (data: TAssignCasesInput): Promise<TAssignCasesResponse> => {
  const url = `/chat/assign-conversation`;

  return axiosInstance.post(url, data);
};

type UseAssignCasesOptions = {
  mutationConfig?: TypedMutationConfig<typeof assignCases, AxiosErrorCustom>;
};

export const useAssignCases = ({ mutationConfig }: UseAssignCasesOptions) => {
  const { onError, ...rest } = mutationConfig || {};

  return useMutation<TAssignCasesResponse, AxiosErrorCustom, TAssignCasesInput>({
    ...rest,
    mutationFn: assignCases,
    onError,
  });
};
